export default function processPaymentGatewayToken(
  rawPGToken: RawPaymentGatewayToken,
): PaymentGateWayToken {
  return {
    token: rawPGToken.Token,
    displayValue: rawPGToken.DisplayValue,
    gateway: rawPGToken.PaymentGateway,
  };
}
